import React, { useState, useEffect } from 'react';
import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Pagination.css';
import PageTriggers from './PageTriggers';

const Pagination = ({ currentPage, totalPages, useHash = false, arrowFlag = true }) => {
  const [inputValue, setInputValue] = useState(currentPage);
  const [isEditing, setIsEditing] = useState(false);

  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    setInputValue(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (useHash) {
      const newSearchParams = new URLSearchParams(searchParams);
      navigate(`?${newSearchParams.toString()}#${page}`);
    } else {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('page', page);
      setSearchParams(newSearchParams);
    }
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputSubmit = (e) => {
    if (e.key === 'Enter') {
      let page = parseInt(inputValue, 10);
      if (isNaN(page) || page < 1) page = 1;
      if (page > totalPages) page = totalPages;
      handlePageChange(page);
      setIsEditing(false);
    }
  };

  const getPageLink = (page) => {
    if (useHash) {
      const newSearchParams = new URLSearchParams(searchParams);
      return `?${newSearchParams.toString()}#${page}`;
    } else {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('page', page);
      return `?${newSearchParams.toString()}`;
    }
  };


  

  return (
    <>
    {arrowFlag && <PageTriggers currentPage={currentPage} totalPages={totalPages} />}
    <nav className="navigation paging-navigation" role="navigation">
      <nav className="text-center">
        <ul className="pagination justify-content-center d-flex align-items-center">
          {!(currentPage === 1 || totalPages === 0) && (
            <li className="page-item">
              <Link className="page-link" to={getPageLink(currentPage - 1)} onClick={(e) => e.currentTarget.blur()}>&laquo;</Link>
            </li>
          )}
          <li className="page-item">
            {isEditing ? (
              <input
                type="number"
                className="form-control"
                value={inputValue}
                onChange={handleInputChange}
                onKeyPress={handleInputSubmit}
                onBlur={() => setIsEditing(false)}
                autoFocus
                style={{ width: '100px', display: 'inline-block' }}
              />
            ) : (
              <span className="page-link pages" onClick={() => setIsEditing(true)}>
                {totalPages === 0 ? '0' : currentPage} of {totalPages}
              </span>
            )}
          </li>
          {!(currentPage === totalPages || totalPages === 0) && (
            <li className="page-item">
              <Link className="page-link" to={getPageLink(currentPage + 1)} onClick={(e) => e.currentTarget.blur()}>&raquo;</Link>
            </li>
          )}
        </ul>
      </nav>
    </nav>
    </>
  );
};

export default Pagination;